import gql from 'graphql-tag';

export default gql`
query GetRemoteUserSettings {
    GetRemoteUserAppSettings(appName: "manifestcentral"){
        appName
        settings
    }
}
`